// SP-3 — the single display-name rule for TPS rows. The seeded default TPS
// is the platform's "no servicer assigned" concept (EntityId = Guid.Empty,
// so entity-name lookups miss); it must READ as intentional everywhere —
// never as a data bug ("Unnamed entity"). Every list/picker/card that labels
// a TPS goes through this helper.

export const NO_SERVICER_ASSIGNED = "No servicer assigned";

const EMPTY_GUID = "00000000-0000-0000-0000-000000000000";

/**
 * True when the TPS actually links a LegalEntity. #3-A makes the entity link
 * optional — an entity-less TPS carries the empty GUID, so entity lookups /
 * the "Linked Entity" link must be gated on this.
 */
export function hasLinkedEntity(entityId: string | null | undefined): boolean {
  return !!entityId && entityId !== EMPTY_GUID;
}

/**
 * Resolve the label for a TPS row. The guard is IDENTITY-based (isPlaceholder),
 * not the mutable isDefault: only the seeded placeholder renders
 * "No servicer assigned". A real TPS always renders its linked legal-entity
 * name, or (when entity-less, #3-A) its own contactName, with a neutral
 * fallback while the name query is in flight or genuinely missing — even if it
 * were somehow flagged isDefault.
 */
export function tpsDisplayName(
  tps: { isPlaceholder: boolean; contactName?: string | null },
  entityName: string | null | undefined,
): string {
  if (tps.isPlaceholder) return NO_SERVICER_ASSIGNED;
  if (entityName?.trim()) return entityName;
  if (tps.contactName?.trim()) return tps.contactName;
  return "(name unavailable)";
}
